import { useSelector } from "react-redux";

function useAuth() {
  const { isLoggedIn, statusToken } = useSelector((store) => store.auth);
  const isAuthorized = isLoggedIn && statusToken === "valid";

  return { isLoggedIn, statusToken, isAuthorized };
}

export default useAuth;
